const PAYMENT_TYPE_BY_METHOD: Record<string, string> = {
  credit_card: 'credito',
  pix: 'pix',
  boleto: 'boleto',
};

const PROJECT_BY_DOMAIN: Array<[RegExp, string]> = [
  [/pagar\.me$/, 'pagarme'],
  [/\.ton\./, 'ton'],
  [/\.stone\./, 'stone'],
];

const SCREEN_BY_ROUTE: Record<string, string> = {
  'delivery-address': 'endereco_entrega',
  'card-data': 'dados_cobranca',
  'pix-success': 'conclusao',
  'boleto-success': 'conclusao',
  'credit-card-success': 'conclusao',
  error: 'erro_carregamento',
};

export function resolveProjectFromHost(hostname: string) {
  const host = hostname.toLowerCase();

  return PROJECT_BY_DOMAIN.find(([pattern]) => pattern.test(host))?.[1] ?? '';
}

export function resolveScreenFromPathname(pathname?: string | null) {
  if (!pathname) return '';

  const segments = pathname.split('/').filter(Boolean);

  if (segments.length <= 1) return 'inicial';

  return SCREEN_BY_ROUTE[segments[1]] ?? '';
}

export function resolvePaymentType(paymentMethod?: string | null) {
  if (!paymentMethod) return '';

  return PAYMENT_TYPE_BY_METHOD[paymentMethod] ?? '';
}
